export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDEN_LOADING = 'HIDEN_LOADING'